<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
               {{$t('SITEPROPS')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('STATUS')">
                    <b-form-select :options="statuses" v-model="pagination.status" value-field="value" text-field="key"></b-form-select>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('DETECTIONID')}}</th>
                    <th>{{$t('DATETIME')}}</th>
                    <th>{{$t('PLAYERID')}}</th>
                    <th>{{$t('STATUS')}}</th>
                    <th>{{$t('USERRESOLVED')}}</th>
                    <th>{{$t('MBASEUSERID')}}</th>
                    <th>{{$t('DETAILS')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                    <template v-for="item in data.root">
                        <tr>
                            <td v-on:click.prevent="item.visible = !item.visible">{{ item.detectionId }}</td>
                            <td v-on:click.prevent="item.visible = !item.visible">{{ item.dateTime }}</td>
                            <td v-on:click.prevent="item.visible = !item.visible">{{ item.data.playerId }}</td>
                            <td v-on:click.prevent="item.visible = !item.visible">{{ $t(item.status.toUpperCase()) }}</td>
                            <td v-on:click.prevent="item.visible = !item.visible">{{ item.username }} {{ item.resolveDateTime }}</td>
                            <td v-on:click.prevent="item.visible = !item.visible">{{ item.resolveMbaseUserId }}</td>
                            <!-- td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon icon="save"></icon> {{$t('SAVE')}}</b-button></td -->
                            <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="item.visible = !item.visible"><icon icon="save"></icon> {{$t('SHOWDETAILS')}}</b-button></td>
                            <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.detectionId)"><icon icon="ban"></icon> {{$t('DELETE')}}</b-button></td>
                        </tr>
                        <tr v-show="item.visible">
                            <td colspan="8">
                                <div class="row">
                                    <div class="col-md-3 mb-4">
                                      <b-button type="reset" size="lg" variant="primary" v-on:click.prevent="item.status = 'approved'; saveRow(item)">{{$t('APPROVE')}}</b-button>
                                    </div>
                                    <div class="col-md-3">
                                      <b-button type="reset" size="lg" variant="danger" v-on:click.prevent="item.status = 'declined'; saveRow(item)">{{$t('DECLINE')}}</b-button>
                                    </div>
                                </div>
                                <div class="row mb-5" v-if="item.data.error">
                                    <div class="col-md-12">
                                        <p>{{ $t('ERROR') }}: {{ item.data.error }}</p>
                                    </div>
                                </div>
                                <div class="row mb-5">
                                    <div class="col-md-1">{{ Math.round(item.data.age) }}</div>
                                    <div class="col-md-2">{{ item.data.gender }}</div>
                                    <div class="col-md-1">{{ item.data.similarity }}</div>
                                    <div class="col-md-2">
                                        <button class="btn-primary btn-lg" style="border: 0px; background-color: #c6dbce;" v-on:click.prevent="item.status = 'approved'; saveRow(item)">
                                            {{ $t('APPROVED') }}
                                        </button>
                                    </div>
                                    <div class="col-md-2">
                                        <button class="btn-primary btn-lg" style="border: 0px; background-color: #9e3d4f;" v-on:click.prevent="item.status = 'declined'; saveRow(item)">
                                            {{ $t('DECLINED') }}
                                        </button>
                                    </div>
                                    <div class="col-md-2">
                                        <button class="btn-primary btn-lg" style="border: 0px; background-color: #f0be5d;" v-on:click.prevent="item.status = 'morework'; saveRow(item)">
                                            {{ $t('MOREWORK') }}
                                        </button>
                                    </div>
                                    <div class="col-md-2">
                                        <button class="btn-primary btn-lg" style="border: 0px; background-color: #c5d1e0;" v-on:click.prevent="item.forArchive = 1; saveRow(item)">
                                            {{ $t('ARCHIVED') }}
                                        </button>
                                    </div>
                                </div>
                                <div class="row mb-5 d-flex flex-row">
                                    <div class="mr-5">
                                        <div class="mb-4">
                                          <p>{{ $t('IDIMAGE') }}</p>
                                          <img :src="item.data.idPhotoBase64" />
                                        </div>
                                    </div>
                                    <div class="mr-5">    
                                        <div class="mb-4">
                                          <p>{{ $t('INITIALIMAGE') }}</p>
                                          <img :src="item.data.initialImage" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-5 d-flex flex-row">
                                    <div class="mr-5">
                                        <div class="mb-4">
                                          <p>{{ $t('FRONTIMAGE') }}</p>
                                          <img :src="item.data.frontImage" />
                                        </div>
                                    </div>
                                    <div class="mr-5">  
                                        <div class="mb-4">
                                          <p>{{ $t('LEFTIMAGE') }}</p>
                                          <img :src="item.data.leftImage" />
                                        </div>
                                    </div>
                                    <div class="mr-5">  
                                        <div class="mb-4">
                                          <p>{{ $t('RIGHTIMAGE') }}</p>
                                          <img :src="item.data.rightImage" />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import Api from '@/api/admin/FaceDetection'

export default {
  name: 'FaceDetection',
  data: function()
  {
    const me = this;
    return {
      data: {},
      formError: {},
      formData:
      {
        key: '',
        value: ''
      },
      statuses: [
        {
          key: me.$t('ALL'),
          value: '',
        },
        {
          key: me.$t('STARTING'),
          value: 'starting',
        },
        {
          key: me.$t('WAITING'),
          value: 'waiting',
        },
        {
          key: me.$t('APPROVED'),
          value: 'approved',
        },
        {
          key: me.$t('DECLINED'),
          value: 'declined',
        },
        {
          key: me.$t('MOREWORK'),
          value: 'morework',
        },
      ],
      pagination:
      {
        query: '',
        status: 'waiting',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.detectionId != 'undefined')
      {
        item.id = item.detectionId;
        delete(item.detectionId);
      }

      const submitData = JSON.parse(JSON.stringify(item));
      submitData.data = JSON.stringify(submitData.data);

      Api.save(submitData, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        for (const item of data.root)
        {
            item.data = JSON.parse(item.data);
            if (typeof item.data.euclideanDistance === 'string')
            {
                item.data.similarity = me.$t('FACENOTDETECTED');
            }
            else
            {
                item.data.similarity = Math.round((1 - item.data.euclideanDistance)*100)+' %';
            }
            item.visible = false;
        }
        me.data = data;
      });
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          Api.deleteRow({id: id}, function(data)
          {
            me.$notify.notice(data);
            me.getData();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    },
    'pagination.status': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
